module.exports = __webpack_public_path__ + "img/rule4.f51fb486.jpg";